import 'jquery-mousewheel/jquery.mousewheel';
import '../vendor/slick';

export default class SlickInit {
  constructor() {
    this.enableBreakpoint = 900;
    this.$slider = $('.group-wrap');
  }

  mySlick() {
    this.$slider.slick({
      arrows: false,
      vertical: true,
      infinite: false,
      centerMode: true,
      centerPadding: '137px',
      responsive: [
          {
              breakpoint: this.enableBreakpoint,
              settings: "unslick"
          }
      ]
    });
    // $('.slick-track').addClass('start')
  }

  sliderItemsStyle() {
    const curentSlide = $('.slick-current');
    const slide = $('.slick-slide');
    slide.css('opacity', '.4');

    curentSlide.css('opacity', '1');
    // curentSlide.css('transition', '.3s');
    curentSlide.prev('.slick-slide').css('opacity', '.7');
    // curentSlide.prev('.slick-slide').css('transition', '.3s');
    curentSlide.prev('.slick-slide').addClass('prev-slide');
    curentSlide.next('.slick-slide').css('opacity', '.7');
    // curentSlide.next('.slick-slide').css('transition', '.3s');
    curentSlide.next('.slick-slide').addClass('next-slide');
  }

  addNextPrevClass() {
    const curentSlide = $('.slick-current');
    // this.sliderItemsStyle();
    // this.sliderItemsContent();
    curentSlide.prev('.slick-slide').addClass('prev-slide');
    curentSlide.next('.slick-slide').addClass('next-slide');
  }

  sliderItemsContent() {
    const curentText = $('.slick-current div .groups-item .groups-item__text');
    const curentView = $('.slick-current div .groups-item .groups-item__view');
    const slideText = $('.slick-slide div .groups-item .groups-item__text');
    const slideView = $('.slick-slide div .groups-item .groups-item__view');

    slideText.css('opacity', '0');
    // slideText.css('transition', '.3s');
    slideView.css('opacity', '0');
    // slideView.css('transition', '.3s');
    curentText.css('opacity', '1');
    // curentText.css('transition', '.3s');
    curentView.css('opacity', '1');
    // curentView.css('transition', '.3s');
  }

  restartSlider() {
    this.$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      $('.slick-slide').removeClass('prev-slide next-slide');
      const curSlide = $(`[data-slick-index="${nextSlide}"]`);
      curSlide.prev('.slick-slide').addClass('prev-slide');
      curSlide.next('.slick-slide').addClass('next-slide');
    });
    this.$slider.on('afterChange', () => {
      // this.addNextPrevClass();
    });
  }

  onWheel() {
    this.$slider.on('mousewheel', (event) => {
      event.preventDefault();
      if (event.deltaY > 0) {
        this.$slider.slick('slickNext');
      } else {
        this.$slider.slick('slickPrev');
      }
    });
  }

  slideClickEvent() {
    $('.slick-slide').click((event) => {
      const slideIndex = $(event.currentTarget).data('slick-index');

      this.$slider.slick('slickGoTo', slideIndex);
    });
  }

  init() {
    if ($(window).width() <= this.enableBreakpoint) {
      return;
    }

    this.mySlick();
    this.addNextPrevClass();
    // this.sliderItemsStyle();
    // this.sliderItemsContent();
    this.restartSlider();
    this.slideClickEvent();
    this.onWheel();
  }
}
